import { render, staticRenderFns } from "./InfoReveal.vue?vue&type=template&id=4b584f10&scoped=true&"
import script from "./InfoReveal.vue?vue&type=script&lang=js&"
export * from "./InfoReveal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b584f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4b584f10', component.options)
    } else {
      api.reload('4b584f10', component.options)
    }
    module.hot.accept("./InfoReveal.vue?vue&type=template&id=4b584f10&scoped=true&", function () {
      api.rerender('4b584f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/containers/InfoReveal.vue"
export default component.exports